async function ensureCostiesBlockedOnline() {
  if (
    !window.ShopSanteCustomer ||
    !window.ShopSanteCustomer.isLoggedIn ||
    !window.ShopSanteCustomer.isCosties
  ) {
    return Promise.resolve();
  }

  if (window.__costiesBlockOnlineSet === true) {
    return Promise.resolve();
  }

  window.__costiesBlockOnlineSet = true;

  try {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          costies_block_online: 'true'
        }
      })
    });
  } catch (e) {
    window.__costiesBlockOnlineSet = false;
    console.error('Unable to set costies_block_online cart attribute', e);
  }
}

function openCartDrawerOptimistic() {
  if (window.__isB2BCustomer) return;
  const drawer = document.querySelector('[data-js-site-cart-sidebar]');
  if (drawer && typeof drawer.show === 'function') {
    drawer.show();
  }
}

function refreshCartRecommendationsDelayed() {
  clearTimeout(window.__cartRecommendationsTimer);

  window.__cartRecommendationsTimer = setTimeout(() => {
    const recommendations = document.querySelector('cart-recommendations');

    if (!recommendations || typeof recommendations.generateRecommendations !== 'function') {
      return;
    }

    recommendations.innerHTML = '';
    recommendations.generateRecommendations();
  }, 1200);
}

function refreshHelperCartNow() {
  return ensureCostiesBlockedOnline()
    .then(() => {
      return fetch(`${window.location.href}?section_id=helper-cart`);
    })
    .then(response => response.text())
    .then(text => {
      const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
      const newCartForm = sectionInnerHTML.getElementById('AjaxCartForm');
      const newCartSubtotal = sectionInnerHTML.getElementById('AjaxCartSubtotal');

      if (!newCartForm || !newCartSubtotal) {
        throw new Error('Unable to refresh helper cart section');
      }

      const cartItems = document.getElementById('AjaxCartForm');
      const cartSubtotal = document.getElementById('AjaxCartSubtotal');

      if (!cartItems || !cartSubtotal) {
        throw new Error('Cart form or subtotal not found');
      }

      cartItems.innerHTML = newCartForm.innerHTML;
      cartItems.ajaxifyCartItems();

      document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
        const count = cartItems.querySelector('[data-cart-count]');
        if (count) elm.textContent = count.textContent;
      });

      document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
        const total = cartItems.querySelector('[data-cart-total]');
        if (total) elm.textContent = total.textContent;
      });

      cartSubtotal.innerHTML = newCartSubtotal.innerHTML;

      openCartDrawerOptimistic();

      const event = new Event('cart-updated');
      cartItems.dispatchEvent(event);

      if (typeof InitSubmit === 'function') {
        InitSubmit();
      }

      if (typeof displayDonationMessageCartDrawer === 'function') {
        displayDonationMessageCartDrawer();
      }

      if (typeof checkShoppingInsurance === 'function') {
        checkShoppingInsurance();
      }

      if (typeof addCartNote === 'function') {
        addCartNote();
      }

      if (typeof ShippingBar === 'function') {
        ShippingBar();
      }

      refreshCartRecommendationsDelayed();
    });
}

window.ShopSanteRefreshCart = refreshHelperCartNow;

if (typeof CartForm !== 'function') {
  class CartForm extends HTMLElement {
    constructor() {
      super();
      this.ajaxifyCartItems();

      if (window.ShopSanteCustomer?.isLoggedIn && window.ShopSanteCustomer?.isCosties) {
        ensureCostiesBlockedOnline();
      }

      this.handleClearCartClick = this.handleClearCartClick.bind(this);
    }

    connectedCallback() {
      document.addEventListener('click', this.handleClearCartClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleClearCartClick);
    }

    handleClearCartClick(e) {
      const clearCartLink = e.target.closest('[data-action="clear-cart"]');

      if (clearCartLink) {
        e.preventDefault();
        this.clearCart();
      }
    }

    ajaxifyCartItems() {
      this.form = this.querySelector('form');

      this.querySelectorAll('[data-js-cart-item]').forEach(item => {
        const remove = item.querySelector('.remove');

        if (remove && remove.dataset.ajaxified !== 'true') {
          remove.dataset.ajaxified = 'true';
          remove.dataset.href = remove.getAttribute('href');
          remove.setAttribute('href', '');

          remove.addEventListener('click', (e) => {
            e.preventDefault();
            this.updateCartQty(item, 0);
          });
        }

        const qty = item.querySelector('.qty');

        if (qty && qty.dataset.ajaxified !== 'true') {
          qty.dataset.ajaxified = 'true';

          qty.addEventListener('input', debounce(e => {
            e.preventDefault();
            e.target.blur();
            this.updateCartQty(item, parseInt(qty.value));
          }, 300));

          qty.addEventListener('click', (e) => {
            e.target.select();
          });
        }
      });
    }

    clearCart() {
      this.form.classList.add('processing');

      fetch(KROWN.settings.routes.cart_clear_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
        .then(response => {
          if (response.ok) {
            window.__costiesBlockOnlineSet = false;
            return ensureCostiesBlockedOnline().then(() => response);
          } else {
            throw new Error('Erreur lors de la suppression du panier');
          }
        })
        .then(() => {
          return refreshHelperCartNow();
        })
        .finally(() => {
          this.form.classList.remove('processing');
        })
        .catch(error => {
          console.error(error);

          let alert = document.createElement('span');
          alert.classList.add('alert', 'alert--error');
          alert.textContent = KROWN.settings.locales.cart_general_error;
          this.form.prepend(alert);
        });
    }

    updateCartQty(item, newQty) {
      this.form.classList.add('processing');

      if (this.querySelector('.alert')) {
        this.querySelector('.alert').remove();
      }

      const requestedQty = Number.isFinite(newQty) ? newQty : 0;
      const minimumQty = parseInt(item?.dataset?.stockPilotMinQty || '0', 10);
      newQty = requestedQty;

      if (Number.isFinite(minimumQty) && minimumQty > 0 && requestedQty < minimumQty) {
        newQty = minimumQty;
        const qty = item.querySelector('.qty');
        if (qty) qty.value = String(minimumQty);
      }

      const body = JSON.stringify({
        id: item.dataset.id,
        quantity: newQty
      });

      fetch(KROWN.settings.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body
      })
        .then(response => {
          if (response.ok) {
            return refreshHelperCartNow();
          } else {
            throw new Error('Something went wrong');
          }
        })
        .then(() => {
          const cartItems = document.getElementById('AjaxCartForm');

          if (
            newQty != 0 &&
            cartItems.querySelector(`[data-js-cart-item][data-id="${item.dataset.id}"]`) &&
            newQty > parseInt(cartItems.querySelector(`[data-js-cart-item][data-id="${item.dataset.id}"]`).dataset.qty)
          ) {
            let alert = document.createElement('span');
            alert.classList.add('alert', 'alert--error');
            alert.innerHTML = KROWN.settings.locales.cart_add_error.replace('{{ title }}', item.dataset.title);
            this.form.prepend(alert);
          }
        })
        .catch(e => {
          console.log(e);

          let alert = document.createElement('span');
          alert.classList.add('alert', 'alert--error');
          alert.textContent = KROWN.settings.locales.cart_general_error;
          this.form.prepend(alert);
        })
        .finally(() => {
          this.form.classList.remove('processing');
        });
    }
  }

  if (typeof customElements.get('cart-form') == 'undefined') {
    customElements.define('cart-form', CartForm);
  }
}

if (typeof CartProductQuantity !== 'function') {
  class CartProductQuantity extends HTMLElement {
    constructor() {
      super();
      this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
      this.querySelector('.qty-plus')?.addEventListener('click', this.changeCartInput.bind(this));
    }

    changeCartInput() {
      this.setAttribute('data-quantity', this.querySelector('.qty').value);

      setTimeout(() => {
        document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
      }, 50);
    }
  }

  if (typeof customElements.get('cart-product-quantity') == 'undefined') {
    customElements.define('cart-product-quantity', CartProductQuantity);
  }
}

if (typeof CartDetails !== 'function') {
  class CartDetails extends HTMLElement {
    constructor() {
      super();
      this.footer = document.querySelector('.shopify-section .footer');

      if (this.footer) {
        this.init();
      }
    }

    init() {
      this.handleScroll = this.handleScroll.bind(this);
      this.handleScroll();
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleScroll);
    }

    handleScroll() {
      if (!this.footer) return;

      const footerRect = this.footer.getBoundingClientRect();
      const footerTop = footerRect.top;
      const viewportMiddle = window.innerHeight / 2;

      if (footerTop <= viewportMiddle) {
        this.classList.add('invisible');
      } else {
        this.classList.remove('invisible');
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
    }
  }

  if (typeof customElements.get('cart-details') == 'undefined') {
    customElements.define('cart-details', CartDetails);
  }
}

if (!window.refreshCart) {
  window.refreshCart = () => {
    openCartDrawerOptimistic();

    clearTimeout(window.__refreshCartTimer);

    window.__refreshCartTimer = setTimeout(() => {
      if (window.__refreshCartPromise) {
        window.__refreshCartQueued = true;
        return;
      }

      window.__refreshCartPromise = refreshHelperCartNow()
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          window.__refreshCartPromise = null;

          if (window.__refreshCartQueued) {
            window.__refreshCartQueued = false;
            window.refreshCart();
          }
        });
    }, 250);
  };
}
